module.exports = __webpack_public_path__ + "img/pr-2.d3b5a553.png";